import React from 'react';

const Portfolio = ({clickHandler}) => (
    <a href="javascript:;"
    onClick={clickHandler}
    >
    <i className="fa fa-address-book-o" aria-hidden="true"></i>添加该文件夹授权人
    </a>
);

export default Portfolio;